import { CSSProperties } from 'react'
import { IconUserPhone, IconWsp } from '../img'
import { homePageLAFISE } from '../data/MochaData'


const StepNoAccept = () => {
    const style: CSSProperties = {
        display: 'flex',
        justifyContent: 'center'
    }

    const Finalizar = (e: any) => {
        e.preventDefault();
        if (window.top !== null && window.top !== undefined)
            window.top.location.href = homePageLAFISE;
    }


    return <>

        <label className='mt-20 mb-30' style={{ ...style, textAlign: 'center', fontSize: '20px', color: '#008866', lineHeight: '30px', fontWeight: 600 }}>
            Gracias por confiar en Seguros <br></br> LAFISE, su proceso ha finalizado, <br></br>
            si requiere mayor información <br></br> puede contactarnos
        </label>
        <div className='pt-10 pb-10 pr-10 pl-10' style={{ display: 'flex', background: '#EBEBEB' }}>
            <div style={{ ...style, width: '30%' }}>
                < IconUserPhone />
            </div>
            <div style={{ width: '70%' }}>
                <label style={{ ...style, textAlign: 'center', fontSize: '16px', color: '#008866', lineHeight: '30px', fontWeight: 600 }}>
                    Atención Telefónica
                </label>
                <label style={{ textAlign: 'center', fontSize: '16px', color: '#4D4D4D' }}>
                    En nuestra central telefónica <br></br> <strong>2246-2700</strong> estamos para <br></br>
                    servirle de 8:00 a.m. a 5:00 p.m. <br></br> de lunes a viernes.
                </label>

            </div>
        </div>
        <div className=' mt-10 pt-10 pb-10 pr-10 pl-10' style={{ display: 'flex', background: '#EBEBEB' }}>
        <div style={{ ...style, width: '30%' }}>
                < IconWsp />
            </div>
            <div style={{ width: '70%' }}> 
                <label style={{ ...style, textAlign: 'center', fontSize: '16px', color: '#008866', lineHeight: '30px', fontWeight: 600 }}>
                    WhatsApp Business
                </label>
                <label style={{ textAlign: 'center', fontSize: '16px', color: '#4D4D4D' }}>
                    Será un gusto atenderle por <br></br> medio de nuestro WhatsApp <br></br> Oficial al <strong> 6094-7218</strong>
                </label>
            </div>
        </div>
        <div className='mt-30' style={style}>
            <button className='btn-auto-cr  next-auto-cr' type="button" onClick={Finalizar}>Finalizar</button>
        </div>
    </>
}

export {
    StepNoAccept
}